import {Button, Form} from "react-bootstrap";
import Style from "./Style.module.css";
import landingStyle from "./LandingPage/LandingCarousel.module.css"

import React, {useEffect, useState} from "react";
import * as UserService from "../api/UserService";
import {useSearchParams} from "react-router-dom";
import {useEffectOnce} from "../hooks/useEffectOnce";
import Cookies from "js-cookie";
import {useTranslation} from "react-i18next";
import InstagramWarning from "./InstagramWarning";
import TranslationSwitch from "../translation/translationSwitch";

function Registration() {
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState(false)
    const [passError, setPassError] = useState(false)
    const [passEqual, setPassEqual] = useState(true)
    const [password, setPassword] = useState("")
    const [passwordRepeat, setPasswordRepeat] = useState("")
    const [nickname, setNickname] = useState("")
    const [success, setSuccess] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(true)
    const [queryParams] = useSearchParams()
    const { t, i18n} = useTranslation('translation', { keyPrefix: 'registrationPage' });

    const isEmailValid = (email) => {
        const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailPattern.test(email);
    };

    const isPassValid = (pass) => {
        return pass.length >= 8
    }

    function resolveEmail(event) {
        let email = event.target.value
        setEmail(event.target.value)
        setEmailError(!isEmailValid(email))
    }

    function resolvePassword(event) {
        let pass = event.target.value
        setPassword(pass)
        setPassError(!isPassValid(pass))
    }

    function resolverPasswordRepeat(event) {
        setPasswordRepeat(event.target.value)
    }

    function resolveNickname(event) {
        setNickname(event.target.value)
    }

    function resolveError(r) {
        if (r.status === 409) {
            window.alert(t('alreadyRegisteredEmailError'))
        } else {
            window.alert(t('smthWentWrongError'))
        }

        setBtnDisabled(false)
    }

    function register() {
        setBtnDisabled(true)
        UserService.register(email, password, nickname, queryParams.get("ref"), i18n.language, () => {
            setSuccess(true)
            setBtnDisabled(false)
        }, resolveError)
    }

    useEffect(() => {
        if (!emailError && !passError && passEqual && nickname !== "") {
            setBtnDisabled(false)
        } else {
            setBtnDisabled(true)
        }
    }, [emailError, passError, passEqual, nickname]);

    useEffect(() => {
        if (password !== passwordRepeat) {
            setPassEqual(false)
        } else {
            setPassEqual(true)
        }
    }, [password, passwordRepeat])

    useEffectOnce(() => {
        if (queryParams.get("ref")) {
            Cookies.set("referral_code", queryParams.get("ref"))
        }

    })

    return (
        <div className={Style.startPageMainContainer}>
            <div style={{position: "absolute", top: "10px", right: "12px"}}>
                <TranslationSwitch></TranslationSwitch>
            </div>
            <InstagramWarning/>
            {success &&
                <div className={Style.setupPageBlocks}>
                    <header>{t('emailSent')} {email}</header>
                    <header>{t('confirmEmail')}</header>
                </div>
            }
            {!success &&
                <Form className={Style.setupPageBlocks}>
                    <div className={Style.regLogoTextContainer}>
                        <span className={landingStyle.logoText}
                        >LeelaOnline</span>
                        <p className={landingStyle.regPageText}>{t('header1_1')} <br/> {t('header1_2')}</p>
                        <p className={landingStyle.regPageText}/>
                        <p className={landingStyle.regPageText}>{t('header2')}</p>
                    </div>
                    <Form.Group className={Style.bodyBaseText}>
                        <Form.Group>
                            <Form.Label>{t('email')}</Form.Label>
                            <Form.Control
                                style={{
                                    marginBottom: emailError ? "0px" : "24px",
                                    backgroundColor: emailError ? "pink" : "white"
                                }}
                                as="input"
                                type="email"
                                required
                                onChange={e => resolveEmail(e)}
                            />
                            {emailError &&
                                <small style={{color: "white"}}>{t('invalidEmail')}</small>
                            }
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t('password')}</Form.Label>
                            <Form.Control
                                required
                                style={{
                                    marginBottom: passError ? "0" : "24px",
                                    backgroundColor: passError ? "pink" : "white"
                                }}
                                as="input"
                                type="password"
                                onChange={e => resolvePassword(e)}
                            />
                            {passError &&
                                <small style={{color: "white"}}>{t('invalidPassword')}</small>
                            }
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t('repeatPassword')}</Form.Label>
                            <Form.Control
                                required
                                style={{
                                    marginBottom: "24px",
                                    backgroundColor: !passEqual && password !== "" ? "pink" : "white"
                                }}
                                as="input"
                                type="password"
                                onChange={e => resolverPasswordRepeat(e)}
                            />
                        </Form.Group>
                        <Form.Label>{t('nickName')}</Form.Label>
                        <Form.Control
                            required
                            as="input"
                            onChange={e => resolveNickname(e)}
                        />
                        <small>{t('nickNameExplanation')}</small>
                        <br/>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <small>{t('registerAgreement_1')}</small>
                            <small>
                                <a target={"_blank"} style={{color: "lightblue"}}
                                   href={"/agreement"}>{t('registerAgreement_2')}</a>
                            </small>
                        </div>
                    </Form.Group>
                    <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
                        <Button
                            style={{backgroundColor: "#59619B", border: "1px outset buttonborder", marginTop: "24px"}}
                            disabled={btnDisabled}
                            className={`${Style.defaultButtonColourAndText} ${Style.buttonWithLink}`}
                            onClick={() => {
                                register()
                            }}
                        >
                            {t('register')}
                        </Button>
                    </div>
                </Form>
            }

        </div>

    )
}

export default Registration